module.exports = __webpack_public_path__ + "img/hero-05.6c9f55f3.jpg";